













































import {Component, Prop, Watch} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import LoaderMixin from '@/mixins/LoaderMixin';
import DebounceMixin from '@/mixins/DebounceMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';

@Component
export default class DialogReroute extends mixins(
  LoaderMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  @Prop() value!: boolean;
  @Prop({default: ''}) id!: string | number;
  @Prop({default: 'items'}) items!: any;
  @Prop({default: 'Cancel'}) cancelText!: string;
  @Prop({default: 'Submit'}) confirmText!: any;
  @Prop({default: '500px'}) maxWidth!: any;
  @Prop({default: 'primary'}) color!: string;
  $refs!: {
    uploader: HTMLFormElement;
  };

  dialog = false;
  listItems = [];
  title = '';
  loadingdata = false;
  search = '';
  idExclude: any = [];
  form: any = {
    selpo_id: '',
    reason: '',
  };
  tmpFile: any = null;
  isLoading = false;

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    this.$emit('input', val);
  }

  @Watch('value', {immediate: true})
  onValueChanged(val: boolean) {
    this.dialog = val;
  }

  errorMessage(val: any) {
    this.$emit('showErrorMessage', val);
    this.close();
  }

  beforeDestroy() {
    this.clear();
  }

  close() {
    this.$refs.uploader.value = null;
    this.tmpFile = null;
    this.isLoading = false;
    this.dialog = false;
    this.clear();
  }
  clear() {
    this.form = {
      selpo_id: '',
      reason: '',
    };
    this.listItems = [];
    this.search = '';
    this.idExclude = [];
  }
  get profile() {
    return JSON.parse(localStorage.getItem('USER') || '{}');
  }
  async onFileChanged(e: any) {
    this.tmpFile = e.target.files[0];
    if (this.tmpFile !== null) {
      try {
        const formData = new FormData();
        formData.append('files', this.tmpFile);
        formData.append('tags', this.title + '-' + this.profile.nik);
        formData.append('type', 'local');

        this.isLoading = true;
        const res = await this.$store.dispatch('users/uploadFile', formData);
        const form = {
          title: this.title,
          files: res.data,
        };
        this.$emit('responSuccess', form);
        this.handleSuccess(res.message);
        this.close();
      } catch (e) {
        this.$refs.uploader.value = null;
        this.tmpFile = null;
        this.isLoading = false;
        this.catchError(e);
        this.close();
      }
    }
  }
  handleFileImport() {
    this.isLoading = true;

    // After obtaining the focus when closing the FilePicker, return the button state to normal
    window.addEventListener(
      'focus',
      () => {
        this.isLoading = false;
      },
      {once: true},
    );

    // Trigger click on the FileInput
    this.$refs.uploader.click();
  }
}
